import axios from '../index'

const getFederationData = query => {
    return axios.get(`federation-activities${query}`)
}

export default {getFederationData}